import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { showMessageToastCustom, translate } from '../../../../utils/util';
import ContainerService from '../../../../services/ContainerService';
import { Breadcrumbs, Input, Card, ConfirmButtons } from '../../../../components/UI/ComponentsUI'
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { checkPermission } from '../../../../services/auth';
import { PERMISSIONS } from '../../../../utils/constants';

const PlantConfig = (props) => {
    const defaultValues = {
        aviexPrealertDays: '',
        expirationAnticipationDays: '',
        expirationPrealertDays: '',
        expirationBlDays: ''
    };
    const [model, setModel] = useState(props.plantConfig || defaultValues);
    const ids = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const [statusValues, setStatusValues] = useState([false, false, false, false, false, false, false, false, false, false, false, false]);

    useEffect(() => {
        if (!props.plantConfig) props.getPlantConfig();
    }, []);

    useEffect(() => {
        if (props.plantConfig) {
            setModel({ ...props.plantConfig });

            setStatusValues([
                props.plantConfig.status01, props.plantConfig.status02,
                props.plantConfig.status03, props.plantConfig.status04,
                props.plantConfig.status05, props.plantConfig.status06,
                props.plantConfig.status07, props.plantConfig.status08,
                props.plantConfig.status09, props.plantConfig.status10,
                props.plantConfig.status11, props.plantConfig.status12
            ]);
        }

        // eslint-disable-next-line
    }, [props.plantConfig]);

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    const onChangeStatus = (event, statusId) => {
        const newStatusValues = [...statusValues];
        newStatusValues[statusId] = event.target.checked;
        setStatusValues(newStatusValues);
    }

    const update = () => {
        if (!validateInputsRequired()) return;

        //Recuperar os status para o model:
        model.status01 = statusValues[0];
        model.status02 = statusValues[1];
        model.status03 = statusValues[2];
        model.status04 = statusValues[3];
        model.status05 = statusValues[4];
        model.status06 = statusValues[5];
        model.status07 = statusValues[6];
        model.status08 = statusValues[7];
        model.status09 = statusValues[8];
        model.status10 = statusValues[9];
        model.status11 = statusValues[10];
        model.status12 = statusValues[11];

        props.updatePlantConfig(model, (data) => {
            if (data.success) {
                showMessageToastCustom(translate('info', 'general'), translate('success', 'general'), 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
            }
            else {
                showMessageToastCustom(translate('warning', 'general'), translate('failed-to-include', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
            }
            props.history.go(-1);
        });
    }

    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: translate('config.plant-config.update-plant-config', 'container') }} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <Card>
                        <div className="row" style={{ marginBottom: '0px' }}>
                            {ids.map((id) => (
                                <div className="input-field no-padding outlined col s5" key={`div_${id}`}>
                                    <Input
                                        id={`status_${id}`}
                                        name={`status_${id}`}
                                        key={id}
                                        label={`Enc. ${id}`}
                                        type="checkbox"
                                        checked={statusValues[id - 1]}
                                        onChange={(event) => { onChangeStatus(event, id - 1) }}
                                    />
                                </div>
                            ))}
                        </div>

                        <div className="row" style={{ marginBottom: '0px' }}>
                            <div className='col s5 no-padding'>
                                <div className="input-field no-padding outlined col s5">
                                    <Input
                                        className="center"
                                        id={`aviexPrealertDays`}
                                        name={`aviexPrealertDays`}
                                        label={translate('config:plant-config:aviex-prealert-days', 'container')}
                                        type="number"
                                        maxlength="2"
                                        value={model?.aviexPrealertDays}
                                        required
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                            <div className='col s5 no-padding'>
                                <div className="input-field no-padding outlined col s5">
                                    <Input
                                        className="center"
                                        id={`expirationAnticipationDays`}
                                        name={`expirationAnticipationDays`}
                                        label={translate('config:plant-config:expiration-anticipation-days', 'container')}
                                        type="number"
                                        maxlength="2"
                                        value={model?.expirationAnticipationDays}
                                        required
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ marginBottom: '0px' }}>
                            <div className='col s5 no-padding'>
                                <div className="input-field no-padding outlined col s5">
                                    <Input
                                        className="center"
                                        id={`expirationPrealertDays`}
                                        name={`expirationPrealertDays`}
                                        label={translate('config:plant-config:expiration-prealert-days', 'container')}
                                        type="number"
                                        maxlength="2"
                                        value={model?.expirationPrealertDays}
                                        required
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                            <div className='col s5 no-padding'>
                                <div className="input-field no-padding outlined col s5">
                                    <Input
                                        className="center"
                                        id={`expirationBlDays`}
                                        name={`expirationBlDays`}
                                        label={translate('config:plant-config:expiration-bl-days', 'container')}
                                        type="number"
                                        maxlength="3"
                                        value={model?.expirationBlDays}
                                        required
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                        </div>
                        {
                            checkPermission(PERMISSIONS.Warehouse_Container.Config.PlantConfig) ?
                                <ConfirmButtons 
                                    onConfirm={() => update()}
                                    onCancel={() => props.history.goBack()} /> :
                                <ConfirmButtons                     
                                    onCancel={() => props.history.goBack()} />                        
                        }
                    </Card>
                </div>
            </div>

        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        plantConfig: state.containerReducer.plantConfig
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updatePlantConfig: (model, callback) => {
            dispatch(ContainerService.updatePlantConfig(model, callback));
        },
        getPlantConfig: (callback) => {
            dispatch(ContainerService.getPlantConfig(callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PlantConfig));
